import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=16cbd37b&scoped=true&"
import script from "./AudioList.vue?vue&type=script&lang=js&"
export * from "./AudioList.vue?vue&type=script&lang=js&"
import style0 from "./AudioList.vue?vue&type=style&index=0&id=16cbd37b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbd37b",
  null
  
)

export default component.exports